import { useEffect, useRef } from 'react'
import { useAppSelector } from './index'
import { sendAwcToBackend } from '@/utils/awin-utils/sendAwcToBackend'

/**
 * Hook that sends AWC to backend when user successfully authenticates
 * Handles all auth methods: email/password, Google, Apple, tokens
 */
export function useAwcOnAuth() {
  const authToken = useAppSelector((state) => state.auth?.access?.token)
  const hasProcessedRef = useRef(false)

  useEffect(() => {
    // If user is authenticated and we haven't processed AWC yet
    if (authToken && !hasProcessedRef.current) {
      hasProcessedRef.current = true

      // Small delay to ensure auth is fully settled
      setTimeout(() => {
        sendAwcToBackend()
      }, 100)
    }

    // Reset flag if user logs out
    if (!authToken) {
      hasProcessedRef.current = false
    }
  }, [authToken])
}
